export default __webpack_public_path__ + "static/media/you-win.d33af4e6.jpg";